import React, { useEffect, useRef, useState } from "react";

import { CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import Swal from "sweetalert2";

import { bigqueryLeadStore } from "helpers/leads/bigquery/bigqueryLead";
import { googleSheetsLeadStore } from "helpers/leads/googleSheets/googleSheetsLead";
import { getDestinationIcon } from "helpers/leads/icon";
import {
    getHubspotModules,
    getLeadHubspotDestinations,
} from "helpers/leads/leadDestinations/getDestinations";
import {
    getServicesAsync,
    getSorceApisAsync,
    postStep1DatasAsync,
} from "helpers/leads/stepHelpers/sendStep1ToServis";
import { getLeadDynamicsDestinations } from "helpers/Sources/dynamics365/dynamics365";

import DynamicsLeadDestination from "components/auth/dynamicsAuth/DynamicsLeadDestination";
import HubspotLeadCRM from "components/organisms/CRMs/HubspotLeadCRM";
import WizardStepLayout from "components/organisms/WizardStepLayout";

import "../../css/leadStep1.css";
import { getAllLeadDestinationTypesAsync } from "../../redux/slices/leadDestinations/leadDestinations.asyncActions";
import { getAllLeadSourcesTypesAsync } from "../../redux/slices/leadSources/leadSources.asyncActions";
import {
    resetLastAddedService,
    lastAddedService as setLastAddedServiceAction,
} from "../../redux/slices/leadsWizardSourceDestination/leadsWizardSourceDestination.slice";
import {
    destinationAndSourceFields,
    stepOneData,
} from "../../redux/slices/step1Datas/step1Datas.slice";
import B24LeadDestination from "../auth/b24Auth/B24LeadDestination";
import BigQueryLeadDestination from "../auth/bigqueryAuth/BigQueryLeadDestination";
import GoogleSheetsLeadDestination from "../auth/googleSheetsAuth/GoogleSheetsLeadDestination";
import SalesForceLeadLogin from "../SalesForceLeadLogin";
import SwalAlertComp from "../SwalAlert";
import AddEditSourceApi from "./AddEditSourceApi";
import CreatWebService from "./CreateWebService";
import ZohoComponent from "./ZohoComponent";

const LeadsStep12 = (props) => {
    const dispatch = useDispatch();
    const [destinationSelections, setDestinationSelections] = useState(null);

    const [sourceSelectionCode, setSourceSelectionCode] = useState("");
    const [destinationSelectionCode, setDestinationSelectionCode] =
        useState("");

    const [sourceApiModalPermision, setSourceApiModalPermision] =
        useState(false);
    const [tiktokStoreData, setTiktokStoreData] = useState({});
    const [tiktokAppStatus, setTiktokAppStatus] = useState(false);
    const [shouldRenderZohoCRM, setShouldRenderZohoCRM] = useState(true);
    const [selectedWebService, setSelectedWebService] = useState("");
    const [selectedSourceApiId, setSelectedSourceApiId] = useState("");
    const [selectedSourceApi, setSelectedSourceApi] = useState("");
    const [selectedConnectedSource, setSelectedConnectedSource] = useState("");

    const [
        selectedConnectedSourceApiPages,
        setSelectedConnectedSourceApiPages,
    ] = useState();
    const [selectedPages, setSelectedPages] = useState([]);
    const [changedSelectedPagesForms, setChangedSelectedPagesForms] = useState(
        [],
    );

    const [file, setFile] = useState("");
    const [selectedPageFormsValue, setSelectedPageFormsValue] = useState("");
    const [businessIdState, setBusinessIdState] = useState("");
    const [webServisPermision, setWebServisPermision] = useState(false);
    const [selectedWebServiceId, setSelectedWebServiceId] = useState();
    const [loadingForWebService, setLoadingForWebService] = useState(false);
    const [connectFaceLeadsList, setConnectFaceLeadsList] = useState([]);
    const [connectWebServicesList, setConnectWebServicesList] = useState([]);
    const [sourceApiList, setSourceApiList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingForSourceApi, setLoadingForSourceApi] = useState(false);
    const [isSourceSelected, setIsSourceSelected] = useState(false);
    const [isDestinationSelected, setIsDestinationSelected] = useState(false);
    const [zohoDestinationName, setZohoDestinationName] = useState();
    const zohoDestinationNameLength = zohoDestinationName?.trim().length ?? 0;
    const isZohoDestinationNameValid =
        zohoDestinationNameLength >= 2 && zohoDestinationNameLength <= 150;
    const [salesDestinationId, setSalesDestinationId] = useState();
    const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
    const [isB24Loading, setIsB24Loading] = useState(false);
    const [b24Data, setB24Data] = useState(null);
    const [shouldRenderB24CRM, setShouldRenderB24CRM] = useState(true);
    const [shouldRenderHubspotCRM, setShouldRenderHubspotCRM] = useState(true);
    const [isBigQueryLoading, setIsBigQueryLoading] = useState(false);
    const [bigQueryData, setBigQueryData] = useState(null);
    const [shouldRenderBigQueryCRM, setShouldRenderBigQueryCRM] =
        useState(true);
    const [hubspotName, setHubspotName] = useState(null);
    const [hubspotData, setHubspotData] = useState(null);
    const [hubspotModules, setHubspotModules] = useState([]);
    const [selectedHubspotModule, setSelectedHubspotModule] = useState("");
    const [isLoadingModules, setIsLoadingModules] = useState(false);

    // Microsoft Dynamics states
    const [shouldRenderDynamicsCRM, setShouldRenderDynamicsCRM] =
        useState(true);
    const [dynamicsData, setDynamicsData] = useState(null);
    const [isDynamicsLoading, setIsDynamicsLoading] = useState(false);

    // Google Sheets states
    const [isGoogleSheetsLoading, setIsGoogleSheetsLoading] = useState(false);
    const [googleSheetsData, setGoogleSheetsData] = useState(null);
    const [shouldRenderGoogleSheetsCRM, setShouldRenderGoogleSheetsCRM] =
        useState(true);
    const [googleSheetsDestinationData, setGoogleSheetsDestinationData] =
        useState(null);
    const [shouldRenderSalesforceCRM, setShouldRenderSalesforceCRM] =
        useState(true);

    const language = useSelector((state) => state.languagesState.languages);

    const allLeadDestinations = useSelector(
        (state) =>
            state.leadAllDestinationsState.getAllLeadDestinationTypes
                .leadDestinations,
    );
    const bussiness = useSelector(
        (state) => state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    );
    const lastAddedService = useSelector(
        (state) => state.leadslastAddedSourceDestinationState.service,
    );
    const lastAddedSourceApi = useSelector(
        (state) => state.leadslastAddedSourceDestinationState.wizzardSource,
    );
    useEffect(() => {
        dispatch(getAllLeadSourcesTypesAsync());
        dispatch(getAllLeadDestinationTypesAsync());
    }, [dispatch]);

    const runDispatcherAfterCreate = () => {
        getSourceApis();
    };

    useEffect(() => {
        let businessId =
            bussiness &&
            bussiness.length > 0 &&
            bussiness.find((element) => element.selected === true);
        if (businessId.id) {
            setBusinessIdState(businessId.id);
        }
    }, [bussiness]);

    // Fetch HubSpot modules when hubspot is selected
    useEffect(() => {
        const fetchHubspotModules = async () => {
            if (destinationSelectionCode === "hubspot") {
                setIsLoadingModules(true);
                try {
                    const response = await getHubspotModules();
                    if (response.status) {
                        setHubspotModules(response.data);
                    }
                } catch (error) {
                    console.error("Error fetching HubSpot modules:", error);
                } finally {
                    setIsLoadingModules(false);
                }
            }
        };

        fetchHubspotModules();
    }, [destinationSelectionCode]);

    const getHubspotList = async () => {
        setLoadingForWebService(true);
        let response = await getLeadHubspotDestinations();
        if (response.status) {
            setConnectWebServicesList(
                response?.data?.map((item) => ({
                    name: item?.name,
                    id: item?.destination_id,
                })) ?? "",
            );
        }
        setLoadingForWebService(false);
    };

    const getDynamicsList = async () => {
        setLoadingForWebService(true);

        let response = await getLeadDynamicsDestinations();
        if (response.status) {
            const dynamicsList =
                response?.data
                    ?.filter((item) => item?.destination_id !== null)
                    ?.map((item) => ({
                        id: item?.destination_id,
                        service_id: item?.id,
                        destination_id: item?.destination_id,
                        name: item?.name,
                    })) ?? [];
            setConnectWebServicesList(dynamicsList);
        }
        setLoadingForWebService(false);
    };

    const newAddedService = async (data) => {
        if (data) {
            await dispatch(setLastAddedServiceAction(data));

            if (destinationSelectionCode === "b24") {
                setSelectedWebServiceId(data.destination_id);
                setSelectedWebService(data.name || "");
                setB24Data(data);
                setNextButtonDisabled(false);
            } else if (destinationSelectionCode === "bigquery") {
                setSelectedWebServiceId(data.destination_id);
                setSelectedWebService(data.name || "");
                setNextButtonDisabled(false);
                await getWebServices(destinationSelectionCode);
            } else if (destinationSelectionCode === "google-sheets") {
                setSelectedWebServiceId(data.destination_id);
                setSelectedWebService(data.name || "");
                setNextButtonDisabled(false);
                await getWebServices(destinationSelectionCode);
            } else if (destinationSelectionCode === "microsoft-dynamics") {
                setSelectedWebServiceId(data.destination_id);
                setSelectedWebService(data.name || "");
                setDynamicsData(data);
                setNextButtonDisabled(false);

                // Refresh the dynamics list to show the newly added item
                getDynamicsList();
            } else if (destinationSelectionCode !== "hubspot") {
                await getWebServices(destinationSelectionCode);
            } else {
                await getHubspotList();
            }
        }
    };

    const destinationOnChange = (value, options) => {
        setZohoDestinationName("");
        dispatch(resetLastAddedService());
        setConnectWebServicesList([]);
        setShouldRenderZohoCRM(true);
        setZohoDestinationName(undefined);
        setDestinationSelections(options.label);
        setIsDestinationSelected(false);
        setDestinationSelectionCode(options.value);
        setShouldRenderB24CRM(true);
        setHubspotName(null);

        // Reset Dynamics state when destination changes
        setShouldRenderDynamicsCRM(true);
        setDynamicsData(null);

        setSelectedWebService("");
        setSelectedWebServiceId("");

        setShouldRenderBigQueryCRM(true);
        setBigQueryData(null);
        setShouldRenderGoogleSheetsCRM(true);
        setGoogleSheetsData(null);
        setGoogleSheetsDestinationData(null);
        setShouldRenderSalesforceCRM(true);
        setSalesDestinationId(null);
        if (value !== "hubspot" && value !== "microsoft-dynamics") {
            getWebServices(options.value);
            return;
        }
        if (value === "hubspot") {
            getHubspotList();
        }
        if (value === "microsoft-dynamics") {
            getDynamicsList();
        }
    };
    const getWebServices = async (value) => {
        setLoadingForWebService(true);
        let response = await getServicesAsync(value);
        setLoadingForWebService(false);
        if (response.status) {
            if (
                value === "b24" ||
                value === "bigquery" ||
                value === "google-sheets"
            ) {
                const b24List = response?.data?.map((item) => ({
                    id: item?.destination_id,
                    service_id: item?.id,
                    destination_id: item?.destination_id,
                    name: item?.name,
                }));
                setConnectWebServicesList(b24List);
            } else if (value === "salesforce") {
                setConnectWebServicesList(
                    response?.data?.map((item) => ({
                        id: item?.destination_id,
                        destination_id: item?.destination_id,
                        name: item?.name,
                    })),
                );
            } else if (value !== "zoho") {
                setConnectWebServicesList(response?.data ?? "");
            } else {
                let zohoOpts = response?.data.map((item) => ({
                    id: item?.destination_id,
                    name: item?.name,
                }));
                setConnectWebServicesList(zohoOpts ?? "");
            }
        }
    };
    const getSourceApis = async () => {
        setLoadingForSourceApi(true);
        let data = {
            business_id: businessIdState,
        };
        let response = await getSorceApisAsync(data);
        if (response.status) {
            setLoadingForSourceApi(false);
            setSourceApiList(response?.data ?? "");
        } else {
            setLoadingForSourceApi(false);
        }
    };

    useEffect(() => {
        if (destinationSelectionCode === "hubspot") return;

        if (lastAddedService !== "") {
            if (destinationSelectionCode === "b24" && !selectedWebServiceId) {
                setSelectedWebServiceId(lastAddedService?.destination_id);
                setSelectedWebService(lastAddedService?.name ?? "");
                setB24Data(lastAddedService);
            } else if (
                destinationSelectionCode === "bigquery" &&
                !selectedWebServiceId
            ) {
                setSelectedWebServiceId(lastAddedService?.destination_id);
                setSelectedWebService(lastAddedService?.name ?? "");
                setBigQueryData(lastAddedService);
            } else if (
                destinationSelectionCode === "google-sheets" &&
                !selectedWebServiceId
            ) {
                setSelectedWebServiceId(lastAddedService?.destination_id);
                setSelectedWebService(lastAddedService?.name ?? "");
                setGoogleSheetsData(lastAddedService);
            } else if (
                destinationSelectionCode === "microsoft-dynamics" &&
                !selectedWebServiceId
            ) {
                setSelectedWebServiceId(lastAddedService?.destination_id);
                setSelectedWebService(lastAddedService?.name ?? "");
                setDynamicsData(lastAddedService);
            } else {
                setSelectedWebService(lastAddedService?.name ?? "");
                setSelectedWebServiceId(lastAddedService?.destination_id ?? "");
            }
            setNextButtonDisabled(false);
        }
    }, [connectWebServicesList, lastAddedService]);

    useEffect(() => {
        if (lastAddedSourceApi !== "") {
            setSelectedSourceApi(lastAddedSourceApi?.name ?? "");
            setSelectedSourceApiId(lastAddedSourceApi?.id ?? "");
        } else {
            setSelectedSourceApi("");
            setSelectedSourceApiId("");
        }
    }, [sourceApiList]);

    const AddNewServiceBtn = () => {
        setWebServisPermision(true);
    };

    const connectWebServicesOnChange = (value, options) => {
        if (value === null) {
            setSelectedWebService(null);
            return;
        }
        setSelectedWebService(options.name);
        setSelectedWebServiceId(options.id);

        if (destinationSelectionCode === "b24") {
            setB24Data({
                destination_id: options.destination_id,
                service_id: options.service_id,
                name: options.name,
            });
        } else if (destinationSelectionCode === "bigquery") {
            setBigQueryData({
                destination_id: options.destination_id,
                service_id: options.service_id,
                name: options.name,
            });
        } else if (destinationSelectionCode === "google-sheets") {
            setGoogleSheetsData({
                destination_id: options.destination_id,
                service_id: options.service_id,
                name: options.name,
            });
        } else if (destinationSelectionCode === "microsoft-dynamics") {
            setDynamicsData({
                destination_id: options.destination_id,
                service_id: options.service_id,
                name: options.name,
            });
            // Hide new connection form when existing dynamics is selected
            setShouldRenderDynamicsCRM(false);
        } else if (destinationSelectionCode === "salesforce") {
            setSalesDestinationId(options.destination_id);
            setSelectedWebServiceId(options.destination_id);
            setSelectedWebService(options.name);
            setShouldRenderSalesforceCRM(false);
        }
        setNextButtonDisabled(false);
    };

    useEffect(() => {
        if (selectedWebServiceId) {
            setNextButtonDisabled(false);
        }
    }, [selectedWebServiceId]);

    const handleCloseServiceModal = () => {
        setWebServisPermision(false);
    };
    const handleCloseSourceApiModal = () => {
        setSourceApiModalPermision(false);
    };

    const showError = (errorMessage) => {
        SwalAlertComp({
            title: "Failed",
            message: errorMessage,
            icon: "error",
            timer: 3000,
        });
    };

    const [bigQueryDestinationData, setBigQueryDestinationData] =
        useState(null);
    // Handle store button click
    const handleBigQueryDestinationStore = async () => {
        setIsLoading(true);

        const payload = {
            name: bigQueryDestinationData?.name,
            install_id: bigQueryDestinationData?.install_id,
            project: bigQueryDestinationData?.project,
            dataset: bigQueryDestinationData?.dataset,
            table: bigQueryDestinationData?.table,
        };

        let response = await bigqueryLeadStore(payload);

        if (response.status) {
            setShouldRenderBigQueryCRM(false);
            setBigQueryData(response?.data);
            await newAddedService(response?.data);
        } else {
            setIsLoading(false);
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
        return response;
    };
    const handleGoogleSheetsDestinationStore = async () => {
        setIsLoading(true);

        const payload = {
            name: googleSheetsDestinationData?.name,
            install_id: googleSheetsDestinationData?.install_id,
            spreadsheet_id: googleSheetsDestinationData?.spreadsheet_id,
            spreadsheet_name: googleSheetsDestinationData?.spreadsheet_name,
            page_name: googleSheetsDestinationData?.page_name,
        };

        let response = await googleSheetsLeadStore(payload);

        if (response.status) {
            setShouldRenderGoogleSheetsCRM(false);
            setGoogleSheetsData(response?.data);
            await newAddedService(response?.data);
        } else {
            setIsLoading(false);
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
        return response;
    };
    useEffect(() => {
        if (destinationSelectionCode === "bigquery" && selectedWebServiceId) {
            setShouldRenderBigQueryCRM(false);
        }
    }, [destinationSelectionCode, selectedWebServiceId]);

    useEffect(() => {
        if (
            destinationSelectionCode === "google-sheets" &&
            selectedWebServiceId
        ) {
            setShouldRenderGoogleSheetsCRM(false);
        }
    }, [destinationSelectionCode, selectedWebServiceId]);

    const toNext = async () => {
        if (sourceSelectionCode === "" && destinationSelectionCode === "") {
            // showError("Please select Source and Destination!");
            setIsDestinationSelected(true);
            setIsSourceSelected(true);
        } else if (destinationSelectionCode === "") {
            // showError("Please select a Destination!");
            setIsSourceSelected(false);
            setIsDestinationSelected(true);
        } else if (
            sourceSelectionCode !== "tiktok" &&
            selectedSourceApiId === "" &&
            selectedPages.length > 0 &&
            changedSelectedPagesForms.length === 0
        ) {
            showError("Please select a page with the form!");
        } else if (
            sourceSelectionCode !== "tiktok" &&
            selectedSourceApiId === "" &&
            selectedPages.length > 0 &&
            selectedPageFormsValue.length === 0
        ) {
            showError("Please select a form!");
        } else if (
            destinationSelectionCode !== "zoho" &&
            destinationSelectionCode !== "salesforce" &&
            destinationSelectionCode !== "microsoft-dynamics" &&
            sourceSelectionCode !== "tiktok" &&
            (destinationSelectionCode !== "bigquery" ||
                !bigQueryDestinationData?.install_id) &&
            (destinationSelectionCode !== "google-sheets" ||
                !googleSheetsDestinationData?.install_id) &&
            !selectedWebServiceId
        ) {
            showError("Please select your destination options!");
        } else if (
            selectedConnectedSource === "" &&
            sourceSelectionCode === "tiktok" &&
            Object.keys(tiktokStoreData).length === 0
        ) {
            showError("Please select your source pages!");
        } else if (
            selectedConnectedSource === "" &&
            sourceSelectionCode === "tiktok" &&
            Object.keys(tiktokStoreData?.selected_pages).length === 0
        ) {
            showError("Please select your source pages!");
        } else {
            let willSendData = props?.step1Data;
            if (
                selectedSourceApiId === "" &&
                sourceSelectionCode !== "tiktok"
            ) {
                if (
                    selectedConnectedSourceApiPages !== undefined &&
                    selectedConnectedSourceApiPages.length > 0
                ) {
                    willSendData = {
                        ...willSendData,
                        business_id: businessIdState,
                        destination_id: selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                    };
                } else {
                    let parentIds = [];
                    for (let item of [...selectedPageFormsValue].filter(
                        (x) => x.parentId !== null && x.parentId !== undefined,
                    )) {
                        parentIds.push(item.parentId);
                    }
                    function onlyUnique(value, index, self) {
                        return self.indexOf(value) === index;
                    }
                    parentIds = parentIds.filter(onlyUnique);
                    willSendData = {
                        ...willSendData,
                        business_id: businessIdState,
                        destination_id: selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                    };
                }
            } else if (
                sourceSelectionCode === "fl" &&
                selectedConnectedSourceApiPages !== undefined
            ) {
                willSendData = {
                    ...willSendData,
                    business_id: businessIdState,
                    destination_id: selectedWebServiceId,
                    destination_type_code: destinationSelectionCode,
                };
            } else if (sourceSelectionCode === "b24") {
                willSendData = {
                    ...willSendData,
                    destination_id: b24Data?.destination_id,
                    destination_type_code: destinationSelectionCode,
                };
            } else if (sourceSelectionCode === "hubspot") {
                willSendData = {
                    ...willSendData,
                    destination_id: hubspotData?.destination_id,
                    destination_type_code: destinationSelectionCode,
                };
            } else if (destinationSelectionCode === "microsoft-dynamics") {
                willSendData = {
                    ...willSendData,
                    destination_id: dynamicsData?.destination_id,
                    destination_type_code: destinationSelectionCode,
                };
            } else {
                willSendData = {
                    ...willSendData,
                    business_id: businessIdState,
                    destination_id: selectedWebServiceId,
                    destination_type_code: destinationSelectionCode,
                };
            }

            if (
                destinationSelectionCode === "salesforce" &&
                salesDestinationId !== undefined
            ) {
                willSendData.destination_id = salesDestinationId;
                willSendData.destination_type_code = destinationSelectionCode;
            }

            if (
                destinationSelectionCode === "bigquery" &&
                bigQueryDestinationData?.install_id &&
                !selectedWebServiceId
            ) {
                const response = await handleBigQueryDestinationStore();

                if (response.status) {
                    willSendData.destination_id =
                        response?.data?.destination_id;
                } else {
                    setIsLoading(false);
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: response?.message ?? "",
                        icon: "error",
                    });
                    return;
                }
            }

            if (
                destinationSelectionCode === "google-sheets" &&
                googleSheetsDestinationData?.install_id &&
                !selectedWebServiceId
            ) {
                const response = await handleGoogleSheetsDestinationStore();

                if (response.status) {
                    willSendData.destination_id =
                        response?.data?.destination_id;
                } else {
                    setIsLoading(false);
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: response?.message ?? "",
                        icon: "error",
                    });
                    return;
                }
            }

            setIsSourceSelected(false);
            setIsDestinationSelected(false);
            postStep1Datas(willSendData);
            dispatch(stepOneData(willSendData));
        }
    };

    useEffect(() => {
        if (destinationSelectionCode !== "bigquery") return;
        if (
            bigQueryDestinationData &&
            Object.values(bigQueryDestinationData).every(
                (value) =>
                    value !== null && value !== undefined && value !== "",
            )
        ) {
            setNextButtonDisabled(false);
        } else {
            setNextButtonDisabled(true);
        }
    }, [destinationSelectionCode, bigQueryDestinationData]);

    useEffect(() => {
        if (destinationSelectionCode !== "google-sheets") return;
        if (
            googleSheetsDestinationData &&
            googleSheetsDestinationData.name &&
            googleSheetsDestinationData.install_id &&
            googleSheetsDestinationData.spreadsheet_id &&
            googleSheetsDestinationData.spreadsheet_name &&
            googleSheetsDestinationData.page_name
        ) {
            setNextButtonDisabled(false);
        } else {
            setNextButtonDisabled(true);
        }
    }, [destinationSelectionCode, googleSheetsDestinationData]);

    const postStep1Datas = async (Step1Data) => {
        setIsLoading(true);
        // todo
        if (destinationSelectionCode === "zoho") {
            Step1Data.destination_name =
                selectedWebServiceId !== undefined &&
                selectedWebServiceId !== null &&
                selectedWebServiceId !== ""
                    ? [...connectWebServicesList].find(
                          (x) => x?.id === selectedWebServiceId,
                      )?.name
                    : zohoDestinationName;
        }
        let response = await postStep1DatasAsync(Step1Data);
        if (response.status) {
            dispatch(destinationAndSourceFields(response.data));
            setIsLoading(false);
            props.nextStep();
            props.setTemplates(response.data.templates);
            step1DataHandle(response);
        } else {
            setIsLoading(false);
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
    };

    const GetOptionValueView = (options, key) => {
        if (
            typeof key === "string" &&
            key !== "" &&
            options &&
            options.length > 0
        ) {
            let label = options?.find((x) => x?.value === key).label || "";
            return {
                label: label,
                value: key,
            };
        } else {
            return {
                label: "",
                value: "none",
            };
        }
    };

    const getSelectOptions = (options) => {
        if (options && options.length > 0) {
            return options.map((x) => ({ label: x.name, value: x.code }));
        } else {
            return [];
        }
    };

    const step1DataHandle = (response) => {
        if (props?.setFilterFieldList !== undefined) {
            props?.setFilterFieldList(
                response?.data?.source_fields?.map((x) => ({
                    label: x?.label,
                    value: x?.key,
                })),
            );
        }
    };

    const toPrevious = () => {
        props.previousStep();
    };

    return (
        <>
            <WizardStepLayout
                primaryTestId="lead-destination-next"
                backTestId="lead-destination-back"
                maxWidth="100%"
                descriptionTitle={
                    language?.lead_wizard?.what_is_destination ??
                    "What is Destination?"
                }
                description={
                    language?.lead_wizard?.what_is_destination_desc ??
                    "The destination is where the processed data is sent or stored. It represents the endpoint that receives and uses the information provided by the source."
                }
                onBack={toPrevious}
                backLabel={language?.buttons?.back ?? "Back"}
                onPrimary={toNext}
                primaryLabel={language?.buttons?.next ?? "Next"}
                primaryDisabled={nextButtonDisabled}
                isLoading={isLoading}
            >
                <Box
                    className={`position-relative z-1 ${
                        isLoading ? "loader-blur" : ""
                    }`}
                >
                    <Autocomplete
                        label={
                            language?.lead?.select_destination ??
                            "Select Destination"
                        }
                        value={GetOptionValueView(
                            getSelectOptions(allLeadDestinations),
                            destinationSelectionCode,
                        )}
                        className="select-image-list tour-destination-select mb-3"
                        disableClearable
                        options={
                            allLeadDestinations &&
                            getSelectOptions(allLeadDestinations)
                        }
                        getOptionLabel={(option) => option.label || ""}
                        onChange={(event, selectedOpt) => {
                            destinationOnChange(
                                selectedOpt?.value,
                                getSelectOptions(allLeadDestinations).find(
                                    (x) => x?.value === selectedOpt?.value,
                                ),
                            );
                            setTiktokAppStatus(false);
                        }}
                        renderInput={(params) => (
                            <div>
                                <TextField
                                    {...params}
                                    data-cy="lead-destination-type"
                                    label={
                                        language?.source_modal
                                            ?.select_destination ??
                                        "Select Destination"
                                    }
                                    error={isDestinationSelected}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <img
                                                style={{
                                                    width: "25px",
                                                    margin: "5px",
                                                    marginTop: "10px",
                                                }}
                                                src={getDestinationIcon(
                                                    params?.inputProps?.value,
                                                )}
                                            />
                                        ),
                                    }}
                                />
                            </div>
                        )}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{
                                    "& > img": { mr: 2, flexShrink: 0 },
                                }}
                                {...props}
                            >
                                <img
                                    width="25"
                                    src={getDestinationIcon(option?.value)}
                                />
                                {option.label}
                            </Box>
                        )}
                    ></Autocomplete>
                    {destinationSelections ? (
                        <>
                            {loadingForWebService && (
                                <Box className="d-flex justify-content-center align-items-center mt-5 mb-5">
                                    <CircularProgress size={17} />
                                </Box>
                            )}

                            {connectWebServicesList.length > 0 &&
                                (destinationSelectionCode === "bigquery"
                                    ? !bigQueryDestinationData?.install_id ||
                                      (!shouldRenderBigQueryCRM &&
                                          selectedWebServiceId &&
                                          bigQueryDestinationData?.install_id)
                                    : destinationSelectionCode ===
                                        "google-sheets"
                                      ? !googleSheetsDestinationData?.install_id ||
                                        (!shouldRenderGoogleSheetsCRM &&
                                            selectedWebServiceId &&
                                            googleSheetsDestinationData?.install_id)
                                      : true) && (
                                    <>
                                        <Form.Group
                                            className="mb-2"
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <FormControl
                                                style={{ width: "100%" }}
                                            >
                                                <Select
                                                    data-cy="lead-existing-destination"
                                                    id="id"
                                                    label={
                                                        "Select " +
                                                        destinationSelections
                                                    }
                                                    onChange={(event) => {
                                                        connectWebServicesOnChange(
                                                            event.target.value,
                                                            connectWebServicesList.find(
                                                                (x) =>
                                                                    x?.id ===
                                                                    event.target
                                                                        .value,
                                                            ),
                                                        );
                                                        setNextButtonDisabled(
                                                            false,
                                                        );
                                                    }}
                                                    value={selectedWebServiceId}
                                                    className="tour-exist-destination-select"
                                                >
                                                    {connectWebServicesList &&
                                                        connectWebServicesList.map(
                                                            (item) => (
                                                                <MenuItem
                                                                    key={
                                                                        item.id
                                                                    }
                                                                    value={
                                                                        item.id
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </MenuItem>
                                                            ),
                                                        )}
                                                </Select>
                                            </FormControl>
                                            {connectWebServicesList &&
                                                connectWebServicesList.length >
                                                    0 &&
                                                shouldRenderB24CRM &&
                                                shouldRenderHubspotCRM &&
                                                shouldRenderDynamicsCRM &&
                                                shouldRenderBigQueryCRM &&
                                                shouldRenderGoogleSheetsCRM &&
                                                shouldRenderSalesforceCRM &&
                                                shouldRenderZohoCRM && (
                                                    <div className="wizard-or-area pb-0">
                                                        {language?.lead?.or ??
                                                            "OR"}
                                                    </div>
                                                )}
                                        </Form.Group>
                                    </>
                                )}

                            {destinationSelectionCode === "salesforce" &&
                                shouldRenderSalesforceCRM && (
                                    <div className="d-block">
                                        <SalesForceLeadLogin
                                            storeSuccess={(id) => {
                                                setSalesDestinationId(id);
                                                setSelectedWebServiceId(id);
                                                setNextButtonDisabled(false);
                                                setShouldRenderSalesforceCRM(
                                                    false,
                                                );
                                                getWebServices("salesforce");
                                            }}
                                        ></SalesForceLeadLogin>
                                    </div>
                                )}

                            {destinationSelectionCode !== "zoho" &&
                                destinationSelectionCode !== "b24" &&
                                destinationSelectionCode !== "hubspot" &&
                                destinationSelectionCode !== "bigquery" &&
                                destinationSelectionCode !== "google-sheets" &&
                                destinationSelectionCode !==
                                    "microsoft-dynamics" && (
                                    <>
                                        {destinationSelectionCode !==
                                            "salesforce" && (
                                            <Button
                                                data-cy="lead-create-destination"
                                                className="py-2 w-full tour-create-new-destination-btn"
                                                variant="outlined"
                                                color="primary"
                                                onClick={AddNewServiceBtn}
                                            >
                                                {language?.lead?.create_new ??
                                                    "Create New"}{" "}
                                                {destinationSelections}
                                            </Button>
                                        )}
                                    </>
                                )}
                            {destinationSelectionCode === "hubspot" &&
                                shouldRenderHubspotCRM && (
                                    <>
                                        <FormControl
                                            className="mb-3"
                                            style={{ width: "100%" }}
                                        >
                                            <TextField
                                                name="name"
                                                label={
                                                    "Hubspot Destination Name"
                                                }
                                                variant="outlined"
                                                onChange={(e) =>
                                                    setHubspotName(
                                                        e.target.value,
                                                    )
                                                }
                                                value={hubspotName}
                                                error={hubspotName === ""}
                                            />
                                        </FormControl>

                                        {/* HubSpot Module Selection */}
                                        <FormControl
                                            className="mb-3"
                                            style={{ width: "100%" }}
                                        >
                                            <Select
                                                value={selectedHubspotModule}
                                                onChange={(e) =>
                                                    setSelectedHubspotModule(
                                                        e.target.value,
                                                    )
                                                }
                                                displayEmpty
                                                variant="outlined"
                                                label="Hubspot Module"
                                                disabled={isLoadingModules}
                                            >
                                                {hubspotModules.map(
                                                    (module) => (
                                                        <MenuItem
                                                            key={
                                                                module.api_name
                                                            }
                                                            value={
                                                                module.api_name
                                                            }
                                                        >
                                                            {
                                                                module.display_name
                                                            }
                                                        </MenuItem>
                                                    ),
                                                )}
                                            </Select>
                                        </FormControl>

                                        <HubspotLeadCRM
                                            onStoreSuccess={(data) => {
                                                setShouldRenderHubspotCRM(
                                                    false,
                                                );
                                                newAddedService(data);
                                                setHubspotData(data);
                                                setSelectedWebServiceId(
                                                    data?.destination_id,
                                                );
                                            }}
                                            hubspotName={hubspotName}
                                            selectedModule={
                                                selectedHubspotModule
                                            }
                                        />
                                    </>
                                )}
                            {destinationSelectionCode === "zoho" &&
                                shouldRenderZohoCRM && (
                                    <div>
                                        <FormControl
                                            className="mb-3"
                                            style={{ width: "100%" }}
                                        >
                                            <TextField
                                                name="name"
                                                label={"Zoho Destination Name"}
                                                variant="outlined"
                                                onChange={(e) =>
                                                    setZohoDestinationName(
                                                        e.target.value,
                                                    )
                                                }
                                                placeholder={
                                                    "Zoho Destination Name"
                                                }
                                                value={
                                                    zohoDestinationName ?? ""
                                                }
                                                error={
                                                    zohoDestinationName !==
                                                        undefined &&
                                                    !isZohoDestinationNameValid
                                                }
                                                helperText={
                                                    zohoDestinationName ===
                                                    undefined
                                                        ? ""
                                                        : zohoDestinationNameLength ===
                                                            0
                                                          ? "Destination name is required"
                                                          : zohoDestinationNameLength <
                                                              2
                                                            ? "Destination name must be at least 2 characters"
                                                            : ""
                                                }
                                                inputProps={{ maxLength: 150 }}
                                                className="tour-zoho-name-input"
                                            />
                                        </FormControl>

                                        <ZohoComponent
                                            name={zohoDestinationName}
                                            destinationSelectionCode={
                                                destinationSelectionCode
                                            }
                                            disabled={
                                                !isZohoDestinationNameValid
                                            }
                                            onStoreSuccess={(data) => {
                                                setShouldRenderZohoCRM(false);
                                                setSelectedWebServiceId(
                                                    data?.destination_id,
                                                );
                                                setSelectedWebService(
                                                    zohoDestinationName ?? "",
                                                );
                                                newAddedService({
                                                    ...data,
                                                    name: zohoDestinationName,
                                                });
                                                setNextButtonDisabled(false);
                                            }}
                                        />
                                    </div>
                                )}

                            {destinationSelectionCode === "b24" &&
                                shouldRenderB24CRM && (
                                    <B24LeadDestination
                                        isButtonLoader={isB24Loading}
                                        setIsButtonLoader={setIsB24Loading}
                                        onSuccess={(data) => {
                                            shouldRenderB24CRM &&
                                                setShouldRenderB24CRM(false);
                                            setB24Data(data);
                                            newAddedService(data);
                                            setNextButtonDisabled(false);
                                        }}
                                    />
                                )}

                            {destinationSelectionCode === "bigquery" &&
                                shouldRenderBigQueryCRM && (
                                    <BigQueryLeadDestination
                                        setBigQueryData={
                                            setBigQueryDestinationData
                                        }
                                        code={destinationSelectionCode}
                                        isButtonLoader={isBigQueryLoading}
                                        setIsButtonLoader={setIsBigQueryLoading}
                                    />
                                )}

                            {destinationSelectionCode === "google-sheets" &&
                                shouldRenderGoogleSheetsCRM && (
                                    <GoogleSheetsLeadDestination
                                        setGoogleSheetsData={
                                            setGoogleSheetsDestinationData
                                        }
                                        code={destinationSelectionCode}
                                        isButtonLoader={isGoogleSheetsLoading}
                                        setIsButtonLoader={
                                            setIsGoogleSheetsLoading
                                        }
                                    />
                                )}

                            {destinationSelectionCode ===
                                "microsoft-dynamics" &&
                                shouldRenderDynamicsCRM && (
                                    <DynamicsLeadDestination
                                        isButtonLoader={isDynamicsLoading}
                                        setIsButtonLoader={setIsDynamicsLoading}
                                        onSuccess={(data) => {
                                            shouldRenderDynamicsCRM &&
                                                setShouldRenderDynamicsCRM(
                                                    false,
                                                );
                                            setDynamicsData(data);
                                            newAddedService(data);
                                            setNextButtonDisabled(false);
                                        }}
                                    />
                                )}
                        </>
                    ) : null}
                </Box>
            </WizardStepLayout>
            {webServisPermision && (
                <CreatWebService
                    businessIdState={businessIdState}
                    newAddedService={newAddedService}
                    destinationSelections={destinationSelections}
                    destinationType={destinationSelectionCode}
                    handleCloseServiceModal={handleCloseServiceModal}
                />
            )}
            {sourceApiModalPermision && (
                <AddEditSourceApi
                    onSuccess={runDispatcherAfterCreate}
                    handleCloseSourceApiModal={handleCloseSourceApiModal}
                />
            )}
        </>
    );
};

export default LeadsStep12;
